module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('PageMenu'), _vm._v(" "), _c('div', {
    staticClass: "zaplac",
    attrs: {
      "id": "app-main"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.token),
      expression: "!token"
    }],
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "min-height": "400px",
      "flex-direction": "column"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "5rem"
    }
  }, [_vm._v("404")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "19px",
      "padding-top": "12px"
    }
  }, [_vm._v("\n                Nieprawidłowy adres strony\n            ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "min-height": "400px",
      "flex-direction": "column"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "2rem"
    }
  }, [_vm._v("UWAGA!")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorReason === 'already_paid'),
      expression: "errorReason === 'already_paid'"
    }],
    staticStyle: {
      "font-size": "1"
    }
  }, [_vm._v("\n                Płatność zakończona pomyślnie\n            ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorReason === 'no_valid_token'),
      expression: "errorReason === 'no_valid_token'"
    }],
    staticStyle: {
      "font-size": "1.5rem"
    }
  }, [_vm._v("\n                Adres strony jest nieprawidłowy\n            ")])]), _vm._v(" "), _c('div', [(_vm.errorReason === '') ? _c('div', {
    staticClass: "order-summary-table"
  }, [_c('div', {
    staticClass: "desktop-order-summary"
  }, [_c('div', {
    staticClass: "dos-name-section",
    staticStyle: {
      "min-height": "100px"
    }
  }, [_c('h3', [_vm._v("Nadawca")]), _vm._v(" "), _c('p', [_vm._v("\n                            " + _vm._s(_vm.orderData.customer.FirstName) + "\n                            " + _vm._s(_vm.orderData.customer.LastName) + "\n                        ")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('p')]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "dos-address-section"
  }, [_c('h3', [_vm._v("Kwota do zapłaty")]), _vm._v(" "), _c('p', [_vm._v("\n                            " + _vm._s(_vm._f("toFixed")(_vm.orderData.delivery.cost)) + "\n                            " + _vm._s(_vm.orderData.delivery.currencyCode) + "\n                        ")])])])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "inline-block",
      "font-weight": "bold",
      "color": "#fff",
      "padding": "1rem 1.5rem",
      "cursor": "pointer",
      "background-color": "#00d6ff"
    },
    on: {
      "click": function($event) {
        return _vm.startPayment()
      }
    }
  }, [_vm._v("Zapłać")])])]), _vm._v(" "), _c('PageFooter')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "section-header no-icon"
  }, [_c('h1', [_vm._v("Zamówienie usługi transportowej")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dos-name-section",
    staticStyle: {
      "min-height": "100px"
    }
  }, [_c('h3', [_vm._v("Odbiorca")]), _vm._v(" "), _c('p', [_vm._v("DTS Transport Sp. z o.o.")]), _vm._v(" "), _c('p', [_vm._v("ul. Wał Miedzeszyński 251,")]), _vm._v(" "), _c('p', [_vm._v("04-866 Warszawa")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dos-address-section"
  }, [_c('h3', [_vm._v("Forma płatności")]), _vm._v(" "), _c('p', [_vm._v("Przelew online")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bf683dc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PayForm.vue
// module id = 262
// module chunks = 1